module.exports = __webpack_public_path__ + "img/风险控制.be858f10.jpg";